/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefineMenuDisplayPrefsSelect_filters$ref = any;
export type SbSharedRefineMenuDisplayPrefsSelect_filters = ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
        readonly displayName: string | null;
        readonly urlLabel: string | null;
        readonly linkReference: string | null;
        readonly linkable: boolean | null;
    } | null> | null;
    readonly " $refType": SbSharedRefineMenuDisplayPrefsSelect_filters$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
    "type": "SearchBrowseFilter",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "values",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseFilterValue",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "urlLabel",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "linkReference",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "linkable",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'a264da0126fcc9a9f2bef2e6376700cb';
export default node;
